<template>
	<section class="search-wrapper">
		<div class="input-container">
			<input
				type="text"
				v-model="text"
				:placeholder="placeholder"
				@keyup.enter="handleSearchButtonClick"
			>
			<img src="@/drc/assets/images/search.png" alt="search" @click="handleSearchButtonClick">
		</div>
		<div class="filter-icon-container" @click="handleSearchButtonClick">
			<span class="filter-icon-text"> {{ $t('managementLabels.search') }} </span>
		</div>
	</section>
</template>

<script>
export default {
	name: "SearchLabels",
	props: {
		triggerSearchLabel: {
			type: Function,
			required: true
		},
		setTextValue: {
			type: Function,
			required: true
		},
		placeholder: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			text: ""
		}
	},
	mounted() {
		this.setText();
	},
	methods: {
		setText() {
			if (this.$route.query) {
				this.text = this.$route.query.text
			}
		},
		handleSearchButtonClick() {
			this.setTextValue(this.text)
			this.triggerSearchLabel();
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.search-wrapper {
	.input-container {
		width: 100%;

		input {
			padding-right: 40px;
		}

		@media (max-width: $mobile) {
			input {
				height: 42px;
			}
		}
	}

	.filter-icon-container {
		@media (max-width: $mobile) {
			flex-basis: 30%;

			.filter-icon-text {
				display: block;
			}
		}
	}
}
</style>
